import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const AddNewClient: React.FC = () => {
  const { t } = useTranslation('client');
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/client/add');
  };

  return (
    <div>
      <button
        type="button"
        onClick={handleClick}
        className="bg-primary/300 text-white rounded-md py-2 px-4"
      >
        {t('graph.add_client')}
      </button>
    </div>
  );
};

export default AddNewClient;
